module.exports = __webpack_public_path__ + "static/media/advertisement.849e752f.svg";